import { useCallback, useState } from 'react'

export const useCarouselControl = ({
  activeIndexProp,
  onActiveIndexChangeProp,
}: {
  activeIndexProp?: number
  onActiveIndexChangeProp?: (index: number) => void
}) => {
  const isControlled = activeIndexProp !== undefined
  const [uncontrolledIndex, setUncontrolledIndex] = useState(0)

  const activeIndex = isControlled ? activeIndexProp : uncontrolledIndex

  const setActiveIndex = useCallback(
    (index: number) => {
      if (!isControlled) {
        setUncontrolledIndex(index)
      }

      onActiveIndexChangeProp?.(index)
    },
    [isControlled, onActiveIndexChangeProp]
  )

  return {
    activeIndex,
    setActiveIndex,
    isControlled,
  }
}
